import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.css";
import "react-toastify/dist/ReactToastify.css";

import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import axios from "axios";

// Global 401 interceptor: clean up expired/invalid sessions and redirect to login.
// All portals (admin/employee/client) render at "/" - there is no separate
// route to navigate away from, so a stale-session redirect has to force a
// reload rather than compare against the current pathname. A guard flag
// keeps a burst of concurrent 401s (e.g. several dashboard widgets firing
// requests at once) from tearing localStorage down more than once.
let sessionCleared = false;
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !sessionCleared) {
      const url = error.config?.url || "";
      const isAuthEndpoint =
        url.includes("/api/auth/login") ||
        url.includes("/api/employee/login") ||
        url.includes("/api/client/login") ||
        url.includes("/api/admin/login") ||
        url.includes("/api/password-reset");
      const isPublicPage =
        window.location.pathname === "/forgot-password" ||
        window.location.pathname === "/reset-password";
      if (!isAuthEndpoint && !isPublicPage) {
        sessionCleared = true;
        localStorage.removeItem("token");
        localStorage.removeItem("employeeUser");
        localStorage.removeItem("employeeToken");
        localStorage.removeItem("clientUser");
        localStorage.removeItem("clientUsername");
        localStorage.removeItem("activePortal");
        if (window.location.pathname === "/") {
          window.location.reload();
        } else {
          window.location.href = "/";
        }
      }
    }
    return Promise.reject(error);
  }
);

// Premium, tactile close button positioned at the top-right of the toast card
const CloseToastButton = ({ closeToast }) => (
  <button
    type="button"
    className="ms-toast__close"
    aria-label="Close notification"
    title="Close"
    onClick={(e) => {
      e.stopPropagation();
      closeToast();
    }}
  >
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  </button>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />
    <ToastContainer
      position="top-right"
      autoClose={4000}
      limit={4}
      newestOnTop
      closeOnClick
      pauseOnHover
      pauseOnFocusLoss
      draggable
      theme="light"
      toastClassName="ms-toast"
      className="ms-toast-container"
      closeButton={CloseToastButton}
    />
  </BrowserRouter>
);

reportWebVitals();
